import { Box, Button } from '@material-ui/core';
import Info from '@material-ui/icons/Info';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Body2 } from '../typography/typography.component';

import './not-saved-warning.styles.scss';

export interface INotSavedWarningProps {
	text: string;
	onSave: () => void;
}

export function NotSavedWarning(props: INotSavedWarningProps): ReactElement {
	const { text, onSave } = props;
	const { t } = useTranslation('general');

	return (
		<Box className="not-saved-warning">
			<Info className="info-icon" />
			<Box>
				<Body2>{text}</Body2>
				<Button
					variant="contained"
					onClick={onSave}
					color="primary"
					className="not-saved-warning-save-button"
				>
					{t('save')}
				</Button>
			</Box>
		</Box>
	);
}
